import { render, staticRenderFns } from "./buygoods.vue?vue&type=template&id=e776930a"
import script from "./buygoods.vue?vue&type=script&lang=js"
export * from "./buygoods.vue?vue&type=script&lang=js"
import style0 from "./buygoods.vue?vue&type=style&index=0&id=e776930a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports